import { render, staticRenderFns } from "./ExpenseRow.vue?vue&type=template&id=1d641f84&scoped=true"
import script from "./ExpenseRow.vue?vue&type=script&lang=js"
export * from "./ExpenseRow.vue?vue&type=script&lang=js"
import style0 from "./ExpenseRow.vue?vue&type=style&index=0&id=1d641f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d641f84",
  null
  
)

export default component.exports